import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'

import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    saveList:[]
  },
  mutations: {
    set_SaveList: (state, device) => {
      state.saveList = device
    },
  },
  actions: {},

})


// WEBPACK FOOTER //
// ./src/store/index.js